const PLAN_LABELS: Record<string, string> = {
  free_trial: 'Free Trial',
  professional: 'Professional Plan',
  enterprise: 'Enterprise Plan',
}

export interface PlanLabelTrial {
  isTrial: boolean
  /** Whole days remaining, already floored at 0 by getTrialStatus. */
  trialDaysLeft: number
  isTrialExpired: boolean
  /** Absent when the org has no recorded creation date. */
  trialEndDate?: string
}

/**
 * The header pill.
 *
 * A free trial carries its remaining days, per the v2 design's
 * "Free Trial · 12 days left" - the countdown is the actionable half, and the
 * plan name alone told a trial user nothing they did not already know.
 *
 * Only the trial gets a suffix. Days are omitted rather than guessed when the
 * trial window is unknown (no `trialEndDate`), because "0 days left" on an
 * account whose dates we never received would be a confident lie.
 */
export const getPlanLabel = (plan?: string, trial?: PlanLabelTrial): string | null => {
  if (!plan) return null
  const label = PLAN_LABELS[plan] ?? plan
  if (!trial?.isTrial || !trial.trialEndDate) return label
  if (trial.isTrialExpired) return `${label} · Expired`
  const { trialDaysLeft } = trial
  if (trialDaysLeft <= 0) return `${label} · Ends today`
  return `${label} · ${trialDaysLeft} day${trialDaysLeft === 1 ? '' : 's'} left`
}
